<template>
  <section style="padding: 0px; margin: 0px">
    <TabView>
      <TabPanel header="Editar perfil">
        <Card>
          <template #content>
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <form class="p-fluid"
                role="registerForm"
                @submit.prevent="handleSubmit(saveUser)"
              >
              <fieldset><base-input
                  v-model="usuario.nombre"
                  rules="required|min:3"
                  label="Nombre"
                  name="Nombre"
                  type="text"
                /></fieldset>
                <fieldset>
                <base-input
                  v-model="usuario.apellido"
                  rules="required|min:3"
                  label="Apellido"
                  name="Apellido"
                  type="text"
                /></fieldset>
                <div class="p-field">
                    <fieldset>
                  <label for="name">Rut (12345678-0)</label>
                  <InputText
                    id="rut"
                    v-model.trim="usuario.rut"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid': submitted && (!validateRut || !usuario.rut),
                    }"
                  />
                  <small class="p-invalid" v-if="submitted && !usuario.rut">
                    Rut es requerido.
                  </small>
                  <small
                    class="p-invalid"
                    v-if="submitted && usuario.rut && !validateRut"
                  >
                    Rut inválido.
                  </small>
                  </fieldset>
                </div>
                <fieldset>
                <base-input
                  name="email"
                  type="email"
                  label="Email"
                  placeholder="Email"
                  rules="required|email"
                  v-model="usuario.email"
                />
                </fieldset>
                <div class="p-d-flex">
                  <Button
                    class="mx-2"
                    label="Guardar Cambios"
                    icon="pi pi-check"
                    type="submit"
                  />
                </div>
              </form>
            </ValidationObserver>
          </template>
        </Card>
      </TabPanel>
      <TabPanel header="Cambiar Contraseña">
        <Card class="p-shadow-0" >
          <template #content>
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <form
                class="p-fluid"
                role="verifiedForm"
                @submit.prevent="handleSubmit(changePassword)"
              >
                <fieldset>
                  <base-input
                    v-model="credentials.old_password"
                    rules="required|min:5"
                    label="Contraseña Actual"
                    name="Contraseña Actual"
                    type="password"
                  />
                </fieldset>
                <fieldset>
                  <base-input
                    v-model="credentials.password"
                    rules="required|min:5"
                    label="Nueva Contraseña"
                    name="Nueva Contraseña"
                    type="password"
                  />
                </fieldset>
                <fieldset>
                  <base-input
                    v-model="credentials.password_repeated"
                    rules="required|min:5"
                    label="Repetir Contraseña"
                    name="Repetir Contraseña"
                    type="password"
                  />
                </fieldset>
                 <div class="p-d-flex">
                  <Button
                    class="mx-2"
                    label="Guardar contraseña"
                    icon="pi pi-check"
                    type="submit"
                  />
                </div>
              </form>
            </ValidationObserver>
          </template>
        </Card>
      </TabPanel>
    </TabView>
  </section>
</template>

<script>
import RutValidator from "@/utils/rut";
import { mapState } from "vuex";
import userService from "@/services/axios/user.service.js";
import CredentialsServices from "@/services/Credentials.service.js";
import localStorage from "@/services/localStorage.service";
export default {
  computed: {
    validateRut() {
      return RutValidator.validaRut(this.usuario.rut);
    },
    ...mapState({
      user: (state) => state.user,
    }),
  },
  mounted() {
    this.usuario.id = this.user.id;
    this.usuario.nombre = this.user.nombre;
    this.usuario.apellido = this.user.apellido;
    this.usuario.email = this.user.email;
    this.usuario.rut = this.user.rut;
  },
  data() {
    return {
      token: null,
      usuario: {
        id: null,
        nombre: null,
        apellido: null,
        email: null,
        rut: null,
      },
      credentialService: new CredentialsServices(),
      credentials: {
        old_password: "",
        password: "",
        password_repeated: "",
      },
      submitted: false,
    };
  },
  methods: {
    saveUser() {
      this.submitted = true;
      if (!this.validateRut) return;
      if (this.usuario.nombre.trim()) {
        if (this.usuario.id) {
          this.updateUser(this.usuario);
        }
      }
    },
    updateUser(usuario) {
      userService
        .updateUser(usuario, usuario.id)
        .then((data) => {
          usuario = data;
          localStorage.setItem("user", data.data);
          this.$swal({
            text: "Usuario editado con éxito, los cambios se aplicarán cuando vuelva a iniciar sesión",
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: `Error`,
            text: error.response.data,
          });
        });
    },
    changePassword() {
      userService
        .updatePassword(this.credentials, this.usuario.id)
        .then(() => {
          this.$swal({
            text: "Contraseña actualizada con éxito",
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: `Error`,
            text: error.response.data,
          });
        });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Usuario/Perfil.vue